<template>
    <div class="device-type-manange relative">
        <div class="buttons">
<!--            <el-button @click="resetForm">重置</el-button>-->
<!--            <el-button @click="search">筛选</el-button>-->
<!--            <el-button :id="'roleAdd'" @click="addDeviceType">新增</el-button>-->
        </div>

        <el-table :data="tableData" border style="width: 100%">
            <el-table-column prop="site_name" label="服务器名称" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="site_url" label="服务器地址" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="api_url" label="接口地址" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="img_prefix_url" label="图片地址" align="center"
                             label-class-name="label"></el-table-column>
            <el-table-column prop="im_socket_url" label="IM链接地址" align="center"
                             label-class-name="label"></el-table-column>
            <el-table-column prop="im_socket_ssl_url" label="IM SSL链接地址" align="center"
                             label-class-name="label"></el-table-column>
            <el-table-column prop="create_date" label="创建时间" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="update_date" label="最后更新时间" align="center"
                             label-class-name="label"></el-table-column>
            <el-table-column
                    prop="address"
                    label="操作"
                    align="center"
                    label-class-name="label"
                    v-slot="scope"
            >
                <el-button :id="'roleEdit'" @click="goEdit(scope.row)" type="text">
                    编辑
                </el-button>
<!--                <el-button :id="'roleDel'" @click="del_user(scope.row)" type="text">删除</el-button>-->
            </el-table-column>
        </el-table>
        <el-pagination
                class="mg-20 ta-r"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[10, 25, 50, 100]"
                :total="total"
                :page-size="perpage"
                :current-page="page"
                @current-change="changePage"
                @size-change="changeSite"
        ></el-pagination>
    </div>
</template>
<script>
    import {check} from "@/utils/checkData";

    export default {
        data() {
            return {
                search_data: null,
                page: 1,
                perpage: 10,
                total: 0,
                tableData: [],
                is_submit: false,
            };
        },
        mounted() {
            // 获取列表
            this.getList();
            localStorage.setItem('prev_page', 'server_list')
        },
        methods: {
            getList() {
                let params = {
                    servername: 'Ruyi_AdminSystemServices',
                    method: 'serverListing',
                    pageinfo: {
                        page: this.page,
                        perpage: this.perpage,
                    },
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        this.is_submit = false;
                        return;
                    }
                    this.tableData = res.data.data.list;
                    this.total = res.data.data.page.count;
                    this.is_submit = false;
                }).catch(() => {
                    this.is_submit = false;
                }).finally(() => {
                    this.is_submit = false;
                });
            },
            // 改变每页条数
            changeSite(index) {
                this.perpage = index;
                this.getList();
            },
            //更换页码
            changePage(index) {
                this.page = index;
                this.getList();
            },

            // 跳转编辑页
            goEdit(data) {
                this.$router.push({
                    name: "serverEdit",
                    params: {
                        id: data.id,
                        site_name: data.site_name,
                        site_url: data.site_url,
                        api_url: data.api_url,
                        img_prefix_url: data.img_prefix_url,
                        im_socket_url: data.im_socket_url,
                        im_socket_ssl_url: data.im_socket_ssl_url,
                    }
                });
            },
            // 重置按钮
            resetForm() {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                this.search_data = "";
                this.getList();
            },
            // 搜索
            search() {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                this.page = 1;
                this.getList();
            },

            // 跳转添加页
            addDeviceType() {
                this.$router.push({name: "serverAdd", params: {}});
            },

            // 删除设备类型
            del_user(val) {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                this.$confirm('确定该删除该服务器吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let params = {
                        servername: 'Ruyi_AdminSystemServices',
                        method: 'deleteServe',
                        params: {
                            id: val.id,
                        }
                    };
                    this.$api.service(params).then(res => {
                        if (!check(res)) {
                            this.is_submit = false;
                            return;
                        }
                        this.$message.success('删除成功！');
                        this.getList();
                        this.is_submit = false;
                    }).catch(() => {
                        this.is_submit = false;
                    }).finally(() => {
                        this.is_submit = false;
                    });
                }).catch(() => {
                    this.is_submit = false;
                }).finally(() => {
                    this.is_submit = false;
                });
            },
        }
    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";
</style>
